const API_BASE =
  process.env.REACT_APP_API_BASE_URL || "";

const API_ROOT = `${API_BASE}/api/kitchen`;

export async function kitchenRequest(
  path,
  options = {}
) {
  const response = await fetch(
    `${API_ROOT}${path}`,
    {
      credentials: "include",
      ...options,
    }
  );

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.detail ||
      data.error ||
      `Request failed (${response.status})`
    );
  }

  return data;
}

export async function getKitchenCsrf() {
  return kitchenRequest("/csrf/");
}

export async function kitchenLogin(
  restaurantId,
  username,
  password,
  csrfToken
) {
  return kitchenRequest(
    `/${restaurantId}/login/`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrfToken,
      },
      body: JSON.stringify({
        username,
        password,
      }),
    }
  );
}

export async function getKitchenUser(restaurantId) {
  return kitchenRequest(`/${restaurantId}/me/`);
}

export async function getKitchenOrders(restaurantId) {
  return kitchenRequest(`/${restaurantId}/orders/`);
}


export async function updateKitchenOrderStatus(
  restaurantId,
  orderId,
  newStatus
) {
  const csrf = await getKitchenCsrf();

  return kitchenRequest(
    `/${restaurantId}/orders/${orderId}/status/`,
    {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRFToken": csrf.csrfToken,
      },
      body: JSON.stringify({
        status: newStatus,
      }),
    }
  );
}

export async function kitchenLogout(restaurantId) {
  const csrf = await getKitchenCsrf();

  return kitchenRequest(`/${restaurantId}/logout/`, {
    method: "POST",
    headers: {
      "X-CSRFToken": csrf.csrfToken,
    },
  });
}